import { ApiResponse, TokenData, IBank, ITag } from '../models';
import * as http from './http';
import ApiService from './service';

export class TagService extends ApiService {
  public async loadAllTags(): Promise<ITag[]> {
    const url = `${this.apiDomain}/api/tag`;
    const resposne = await http.get<ApiResponse<ITag[]>>(url, this.store);
    return resposne?.data?.data;
  }

  public async updateTag(data: ITag, id: string) {
    const url = `${this.apiDomain}/api/tag/${id}`;
    const response = await http.put<ApiResponse<string>>(url, data, this.store);
    return response.data;
  }

  public async createTag(data: ITag) {
    const url = `${this.apiDomain}/api/tag`;
    const response = await http.post<ApiResponse<string>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteTag(id?: string) {
    const url = `${this.apiDomain}/api/tag/${id}`;
    const response = await http.remove<ApiResponse<string>>(url, this.store);
    return response.data;
  }
}
